<template>
  <klarna-placement
    v-if="$variable('settings.enableKlarna')"
    :id="`klarna-placement-${namespace}`"
    class="klarna-messaging"
    :data-key="key"
    :data-locale="locale"
  />
</template>

<script>

/**
 * Vue: Klarna messaging (klarna-messaging)
 * -----------------------------------------------------------------------------
 * Klarna on-site messaging component.
 *
 * @param {String} namespace - Placement namespace.
 * @param {Number} price - Product, variant, or cart price.
 * @param {Object|Boolean} variant - Canvas formatted variant object.
 *
 */
export default {
  name: 'KlarnaMessaging',

  props: {
    namespace: {
      type: String,
      default: '',
      required: true,
    },
  },

  computed: {

    /**
     * Compute placement key.
     * @returns {String}
     */
    key() {
      return 'top-strip-promotion-badge'
    },

    /**
     * Compute locale.
     * @returns {String}
     */
    locale() {
      return `${cnvs.store.language}-${cnvs.store.country}`
    },
  },

  mounted() {
    this.refreshPlacement()
  },

  methods: {

    /**
     * Refresh placement.
     */
    async refreshPlacement() {
      if (!window.Klarna) {
        return
      }

      await this.$nextTick()
      window.Klarna.OnsiteMessaging.refresh()
    },
  },
}
</script>

<style lang="scss">
@import './klarna-messaging';
</style>
